import {parseISO, getTime} from 'date-fns';

export default (list, field, order = 'asc') =>
  [...list].sort((a, b) => {
    const timeA = a[field] ? getTime(parseISO(a[field])) : 0;
    const timeB = b[field] ? getTime(parseISO(b[field])) : 0;
    return order === 'asc' ? timeA - timeB : timeB - timeA;
  });
